import { GamePack } from '@/API';
import CloseIcon from '@/components/Icons/CloseIcon';
import DragIcon from '@/components/Icons/DragIcon';
import clsx from 'clsx';

interface PromptSelectionCardProps {
  text: string;
  gamePack?: GamePack;
  className?: string;
  onRemove?: () => void;
}

export default function SelectedPromptCard(props: PromptSelectionCardProps) {
  return (
    <div
      className={clsx(
        'flex w-full p-8 border-1 border-primary-500 bg-primary-100 rounded-xs items-center justify-between gap-8',
        props.className
      )}
    >
      <DragIcon className="grow-0 shrink-0 text-neutral-400 w-24 h-24" />
      <div className="flex items-center grow-1">
        <div>
          <p className="text-[16px] leading-20 mb-4 font-semibold">{props.text}</p>
          <p className="text-body-xs text-neutral-400 uppercase tracking-[0.24px] font-semibold">
            {props.gamePack?.name ?? 'Custom Prompt'}
          </p>
        </div>
      </div>
      <button onClick={props.onRemove} className="grow-0 shrink-0">
        <CloseIcon className="text-neutral-400 w-20 h-20" />
      </button>
    </div>
  );
}
